<body>
    <!--  Body Wrapper -->
    <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
      data-sidebar-position="fixed" data-header-position="fixed">
  
      <div class="d-flex justify-content-end">
        <button (click)="close()" type="button" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="body-wrapper">
        <div class="container-fluid ">
          <div class="row">
            <div class="container my-4">
  
              <div class="align-items-center justify-content-between">
  
                <div class="card">
  
                  <div class="card-body">
                    <h5 id="upper" class="" style="color: black;">Informations Super administrateur</h5>
                    <div class="container mt-4">
  
                      <form>
                        <div class="row g-3">
                          <div class="col-12 col-md-4">
                            <label for="nom" class="form-label">Nom</label>
                            <input [(ngModel)]="item.nom" name="nom" type="text" class="form-control" id="nom"
                              placeholder="Votre nom">
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="prenom" class="form-label">Prénom</label>
                            <input [(ngModel)]="item.prenom" name="prenom" type="text" class="form-control" id="prenom"
                              placeholder="Votre prénom">
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="telephone" class="form-label">Téléphone</label>
                            <input [(ngModel)]="item.telephone" name="telephone" type="text" class="form-control"
                              id="telephone" placeholder="( ex : 97 00 00 00 )">
                          </div>
  
                          <div class="col-12 col-md-4">
                            <label for="mail" class="form-label">Adresse email</label>
                            <input [(ngModel)]="item.email" name="mail" type="text" class="form-control" id="mail"
                              placeholder="( ex : johndoe@gmail.com )">
                          </div>
                          <div class="col-12 col-md-4">
                            <label>Sexe</label>
                            <select [(ngModel)]="item.sexe" name="sexe"  class="form-select">
                              <option value="Masculin">Masculin</option>
                              <option value="Féminin">Féminin</option>
                            </select>
                          </div>
                          
                          <!-- <div class="col-12 col-md-4">
                            <label>Situation matrimoniale</label>
                            <select [(ngModel)]="item.situation_matrimoniale" name="situation_matrimoniale" class="form-select">
                              <option value="Marié(e)">Marié(e)</option>
                              <option value="Célibataire">Célibataire</option>  
                              <option value="Divorcé(e)">Divorcé(e)</option>
                              <option value="Veuf/Veuve">Veuf/Veuve</option>
                              <option value="Séparé(e)">Séparé(e)</option>
                            </select>
                          </div> -->
                          <div class="col-12 col-md-4">
                            <label for="departement" class="form-label">Pays</label>
                            <select [(ngModel)]="item.pays_id" name="pays" class="form-select"
                              id="pays" (change)="getvilleByPays($event.target.value)">
                              <option selected>Choisir le pays</option>
                              <option *ngFor="let item of departementItems" [value]="item.id">{{ item.name }}</option>
                            </select>
                          </div>
  
                          <div class="col-12 col-md-4">
                            <label for="ville" class="form-label">Ville</label>
                            <select [(ngModel)]="item.ville_id" name="ville" class="form-select" id="ville"  >
                              <option selected>Choisir la ville</option>
                              <option *ngFor="let item of communeItems" [value]="item.id">{{ item.name }}</option>
                            </select>
                          </div>
  
                          <!-- <div class="col-12 col-md-4">
                            <label for="arrondissement" class="form-label">Arrondissement</label>
                            <select [(ngModel)]="item.arrondisement_id" name="arrondissement" class="form-select"
                              id="arrondissement">
                              <option selected>Choisir l'arrondissement</option>
                              <option *ngFor="let item of arrondissementItems" [value]="item.id">{{ item.nom }}</option>
                            </select>
                          </div> -->
  
  
  
  
                          <!-- <div class="col-12 col-md-4">
                            <label for="cooperative" class="form-label">Coopérative </label>
                            <select [(ngModel)]="item.cooperative_id" name="cooperative" class="form-select"
                              id="cooperative">
                              <option selected>Choisir la coopérative</option>
                              <option *ngFor="let item of cooperativeItems" [value]="item.reference">{{item.nom}}</option>
                            </select>
                          </div> -->
                          <!-- <div class="col-12 col-md-4">
                            <label for="cooperative" class="form-label">Rôle </label>
                            <select [(ngModel)]="item.role_id" name="cooperative" class="form-select"
                              id="cooperative">
                              <option selected>Choisir le rôle</option>
                              <option [value]="3">Super administrateur </option>
                              <option [value]="1">Administrateur </option>
                            </select>
                          </div> -->
  
  
                        </div>
                        <div class="d-flex justify-content-end mt-4">
                          <a title="Cliquez ici pour annuler " href="javascript: void(0);" (click)="close()"
                            class="btn btn-secondary me-3"
                            style="color: white; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                            Annuler &nbsp;
                          </a>
  
                          <a (click)="addSuperAdministrateur()" title="Cliquez ici pour enregistrer "
                            href="javascript: void(0);"class="btn"
                            style="color: white; background-color: #578D63; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                            Enregistrer &nbsp;<i class="pi pi-save " style="font-size: 1rem"></i>
  
                          </a>
                        </div>
  
                      </form>
  
                    </div>
  
  
                  </div>
                </div>
              </div>
  
  
  
            </div>
  
          </div>
        </div>
      </div>
    </div>
  
  </body>
  